/**
 * Sanitize a post-login return target. Only same-origin absolute PATHS are
 * allowed ("/campaigns", "/campaigns/abc?tab=1"); anything that could redirect
 * off-site — "//evil.com", "https://evil.com", "javascript:..." — is dropped
 * back to the default landing route.
 */
const DEFAULT_TARGET = "/dashboard";

// eslint-disable-next-line no-control-regex
const CONTROL_CHARS = /[\u0000-\u001f]/;

export function sanitizeRedirectPath(raw: string | undefined | null): string {
  if (!raw) return DEFAULT_TARGET;
  // Must start with a single slash and not a second slash or backslash
  // (protocol-relative URL) — those escape the origin.
  if (!raw.startsWith("/")) return DEFAULT_TARGET;
  if (raw.startsWith("//") || raw.startsWith("/\\")) return DEFAULT_TARGET;
  // No ASCII control characters (a "/\tjavascript:" style smuggle).
  if (CONTROL_CHARS.test(raw)) return DEFAULT_TARGET;
  return raw;
}
